/**
 * Firebase client SDK initialisation.
 *
 * Config is read from Vite env vars (set in Replit Secrets):
 *   VITE_FIREBASE_API_KEY
 *   VITE_FIREBASE_AUTH_DOMAIN
 *   VITE_FIREBASE_PROJECT_ID
 *   VITE_FIREBASE_APP_ID
 *
 * When vars are absent, `firebaseConfigured` is false and the AuthContext
 * will surface a setup-required message instead of crashing.
 */
import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY as string | undefined;
const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined;
const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined;
const appId = import.meta.env.VITE_FIREBASE_APP_ID as string | undefined;

export const firebaseConfigured = Boolean(apiKey && authDomain && projectId && appId);

let app: FirebaseApp;
let auth: Auth;

if (firebaseConfigured) {
  app = getApps().length
    ? getApps()[0]
    : initializeApp({ apiKey, authDomain, projectId, appId });
  auth = getAuth(app);
} else {
  console.warn(
    "[firebase] Missing VITE_FIREBASE_* env vars — authentication disabled. " +
    "Add them in Replit Secrets and restart.",
  );
  app = {} as FirebaseApp;
  auth = {} as Auth;
}

export { app, auth };
